function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from "react";
import CivicLogo from "./CivicLogo";
import CivicLogoInverted from "./CivicLogoInverted";
import CivicLogoAnimated from "./CivicLogoAnimated";
import CivicLogoAnimatedInverted from "./CivicLogoAnimatedInverted";
import CivicLogoC from "./CivicLogoC";
import CivicLogoCAnimated from "./CivicLogoCAnimated";
import CivicLogoCInverted from "./CivicLogoCInverted";
import CivicSandboxLogoInverted from "./CivicSandboxLogoInverted";
import MasterBuilders from "./MasterBuilders";
import HackOregonLogo from "./HackOregonLogo";

function Logo(_ref) {
  var type = _ref.type,
      alt = _ref.alt,
      other = _objectWithoutProperties(_ref, ["type", "alt"]);

  switch (type) {
    case "standardLogo":
      return React.createElement(CivicLogo, {
        alt: alt
      });

    case "standardLogoInverted":
      return React.createElement(CivicLogoInverted, {
        alt: alt
      });

    case "standardLogoAnimated":
      return React.createElement(CivicLogoAnimated, {
        alt: alt
      });

    case "standardLogoAnimatedInverted":
      return React.createElement(CivicLogoAnimatedInverted, {
        alt: alt
      });

    case "squareLogo":
      return React.createElement(CivicLogoC, _extends({
        alt: alt
      }, other));

    case "squareLogoAnimated":
      return React.createElement(CivicLogoCAnimated, {
        alt: alt
      });

    case "squareLogoInverted":
      return React.createElement(CivicLogoCInverted, {
        alt: alt
      });

    case "sandboxLogoInverted":
      return React.createElement(CivicSandboxLogoInverted, {
        alt: alt
      });

    case "hackOregon":
      return React.createElement(HackOregonLogo, {
        alt: alt
      });

    case "masterBuilders":
      return React.createElement(MasterBuilders, {
        alt: alt
      });

    default:
      return React.createElement(CivicLogoAnimated, {
        alt: alt
      });
  }
}

Logo.displayName = "Logo";
Logo.defaultProps = {
  type: "standardLogoAnimated",
  alt: "CIVIC Logo"
};
export default Logo;